// *********************************************************************************************************************
// Custom JavaScript
// *********************************************************************************************************************


// =====================================================================================================================
// Breakpoint Manager
// =====================================================================================================================
import BreakpointManager from './breakpoint-manager'

// Custom Breakpoints object
const breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1460,
}

// Instantiate the Breakpoint Manager
const breakpointManager = new BreakpointManager(breakpoints, true);



// =====================================================================================================================
// Splide
// =====================================================================================================================

// import Splide from '@splidejs/splide';


// Move all Modal Window elements to the body root
document.addEventListener('DOMContentLoaded', function() {
    const modalElements = document.querySelectorAll('.modal');

    modalElements.forEach(modal => {
        document.body.appendChild(modal);
    });
});

// Stop Videos on Modal Close
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.video-modal').forEach(function (modal) {
        modal.addEventListener('hide.bs.modal', function (e) {
            let originalSrc = modal.querySelector('iframe').src;
            modal.querySelector('iframe').src = originalSrc;
        });
    });
});


// User Login Functionality
document.addEventListener('DOMContentLoaded', function() {
    if (typeof wpUserData !== 'undefined' && wpUserData.isLoggedIn) {
        document.querySelector('.logged-in-user-menu a').append(' ' + wpUserData.FirstName);
    }
});